import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/firestore'
// @ts-ignore
import Share from 'vue-social-share';
// @ts-ignore
import { VueHammer } from 'vue2-hammer';
// @ts-ignore
import VueAnalytics from 'vue-analytics'

let SocialSharing = require('vue-social-sharing');

Vue.config.productionTip = false;



// firebase init goes here
const config = {
  apiKey: "AIzaSyCvkWr_ML2PUsB1CNU78nMCO-rPL92pNLs",
  authDomain: "meishi-13f87.firebaseapp.com",
  databaseURL: "https://meishi-13f87.firebaseio.com",
  projectId: "meishi-13f87",
  storageBucket: "meishi-13f87.appspot.com",
  messagingSenderId: "796131641106",
  appId: "1:796131641106:web:12061b4a751b970a"
};

firebase.initializeApp(config);
export const storage = firebase.storage();
export const firestore = firebase.firestore();
Vue.use(Share);
Vue.use(SocialSharing);
Vue.use(VueHammer);

Vue.use(VueAnalytics, {
  id: 'UA-146517561-1',
  router
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


